import React, { useState } from "react";
import PropTypes from "prop-types";
import { Navbar, NavbarBrand } from "shards-react";

import { Dispatcher, Constants } from "../../../flux";
import logo from "../../../images/logo.png";
class SidebarMainNavbar extends React.Component {
  constructor(props) {
    super(props);

    this.handleToggleSidebar = this.handleToggleSidebar.bind(this);
  }

  handleToggleSidebar() {
    Dispatcher.dispatch({
      actionType: Constants.TOGGLE_SIDEBAR,
    });
  }

  render() {
    const { hideLogoText } = this.props;
    return (
      <div className="main-navbar">
        <Navbar
          // className="align-items-stretch bg-white flex-md-nowrap border-bottom p-5"
          className="align-items-center bg-white flex-md-nowrap border-bottom "
          type="light"
        >
          {/* <NavbarBrand
            className="w-100 "
            href="#"
            style={{ lineHeight: "25px" }}
          > */}
          <div style={{ marginTop: "0.5em", marginBottom: "0.5em" }}>
            <img
              src={logo}
              alt="Logo"
              style={{ maxWidth: "100%", display: "block", margin: "0 auto" }}
            />
          </div>
          {/* </NavbarBrand> */}
          {/* <NavbarBrand
            className="w-100 mr-0"
            href="#"
            style={{ lineHeight: "25px" }}
          >
            <div className="d-table m-auto">
              {!hideLogoText && (
                <span className="d-none d-md-inline ml-1">PropEx</span>
              )}
            </div>
          </NavbarBrand> */}
          {/* eslint-disable-next-line */}
          <a
            className="toggle-sidebar d-sm-inline d-md-none d-lg-none"
            onClick={this.handleToggleSidebar}
          >
            <i className="material-icons">&#xE5C4;</i>
          </a>
        </Navbar>
      </div>
    );
  }
}

SidebarMainNavbar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool,
};

SidebarMainNavbar.defaultProps = {
  hideLogoText: false,
};

export default SidebarMainNavbar;
